import React from "react";
import tw from "twin.macro";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import Hero from "components/hero/BackgroundAsImageWithCenteredContent.js";
import Hero2 from "components/hero/TwoColumnWithVideo.js";

import Features from "components/features/VerticalWithAlternateImageAndText.js";
import Blog from "components/blogs/ThreeColSimpleWithImage.js";
import Testimonial from "components/testimonials/TwoColumnWithImage.js";
import ContactUsForm from "components/forms/SimpleContactUs.js";
import Footer from "components/footers/SimpleFiveColumn.js";
import { Subheading } from "components/misc/Headings";
import Pricing from "components/pricing/ThreePlans.js";
import GoogleMapReact from "google-map-react";
const defaultProps = {
  center: {
    lat: 23.1572,
    lng: 72.5175,
  },
  zoom: 11,
};
const AnyReactComponent = ({ text }) => <div>{text}</div>;

export default () => {
  const HighlightedText = tw.span`text-red-600`;
  const imageCss = tw`rounded-4xl`;

  return (
    <>
      <a
        href="https://api.whatsapp.com/send?phone=+919537755454&text=Hello, I want to book a slot for Box-Cricket."
        class="whatsapp-button"
        target="_blank"
        style={{ position: "fixed", right: 25, bottom: 25, zIndex: 9999 }}
      >
        <img
          src="https://i.ibb.co/VgSspjY/whatsapp-button.png"
          alt="botão whatsapp"
        />
      </a>

      <AnimationRevealPage>
        <Hero />
        <Hero2
          heading={
            <>
              Football ⚽️ unites us{" "}
              <HighlightedText>All. 🐐🐐🐐</HighlightedText>
            </>
          }
          description="Football is not just about scoring goals, it's about winning together as a team. Come at Yorker Club to play & meet the players and make new buddies on the field, while playing your passion (Football ❤️)"
          // imageSrc="https://images.unsplash.com/photo-1504674900247-0877df9cc836?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=768&q=80"
          imageCss={imageCss}
          imageDecoratorBlob={true}
          primaryButtonText="Book your slot"
          watchVideoButtonText="Checkout on Map"
        />
        <Testimonial />

        <Features />
        <Pricing
          subheading={<Subheading>Pricing</Subheading>}
          primaryButtonText={"Book Now"}
          description={
            "We at Yorker Club believe that every person should be able to play this game, so keeping that in mind we have curated such a reasonable & flexible plans to subscribe"
          }
          heading={
            <>
              Reasonable & Flexible <HighlightedText>Plans.</HighlightedText>
            </>
          }
          plans={[
            {
              name: "Pay-As-You-Play Plan",
              price: "₹1200",
              duration: "Hourly",
              mainFeature: "Monday-Friday",
              features: [
                "30 Templates",
                "7 Landing Pages",
                "12 Internal Pages",
                "Basic Assistance",
              ],
              text: "This plan is perfect for players who want to play occasionally or on a casual basis. Under this plan, you can book a slot for a one-hour game and pay a flat fee of 1200/- per hour. This plan does not require any long-term commitment or upfront payment, making it a great option for those who want to play on their own schedule",
            },
            {
              name: "Weekends",
              price: "₹1500",
              duration: "Hourly",
              mainFeature: "Saturday & Sunday",
              features: [
                "60 Templates",
                "15 Landing Pages",
                "22 Internal Pages",
                "Priority Assistance",
              ],
              featured: true,
              text: "This plan is perfect for players who want to play occasionally or on a casual basis. Under this plan, you can book a slot for a one-hour game and pay a flat fee of 1500/- per hour. This plan does not require any long-term commitment or upfront payment, making it a great option for those who want to play on their own schedule",
            },
            {
              name: "Team Plan",
              price: "₹XXXX",
              duration: "Monthly",
              mainFeature: "For Enthusiastic Team Players (Coming Soon)",
              features: [
                "90 Templates",
                "27 Landing Pages",
                "37 Internal Pages",
                "Personal Assistance",
              ],
              text: "Our team plan is ideal for groups of players who want to play together on a regular basis. Under this plan, you can form a team of X players and book a slot for a one-hour game each week. The cost per team is $X per week, which can be split among the players. This plan requires a minimum commitment of X weeks and upfront payment, but offers a discounted rate compared to the pay-as-you-play plan.",
            },
          ]}
        />
        {/* <Blog /> */}
        {/* <ContactUsForm /> */}
        <div style={{ height: "40vh", width: "100%" }}>
          <GoogleMapReact
            bootstrapURLKeys={{ key: "" }}
            defaultCenter={defaultProps.center}
            defaultZoom={defaultProps.zoom}
          >
            <AnyReactComponent
              lat={59.955413}
              lng={30.337844}
              text="My Marker"
            />
          </GoogleMapReact>
        </div>
        <Footer />
      </AnimationRevealPage>
    </>
  );
};
